import React, { useState } from 'react';
import { connect } from 'react-redux';
import { productType } from '../../Constant';


const InternetSubscriber = ({ subscriber }) => {
  const isDisplayProductStatus = subscriber.productStatus != 'Active' && subscriber.productStatus != 'INS' && subscriber.productStatus != 'A';
  let title = '';
  let isEmail = false;

  switch (subscriber.internetProductType) {
    case productType.Internet:
    case productType.InternetInfra:
      const address = subscriber.customerAddress?.split(',').map(x => x.trim()).join(', ')?.trim();
      title = (address && address?.length != 1) ? address : (subscriber.packageName ?? subscriber.productDesc);
      break;
    case productType.InternetIsp:
    case productType.Mapa:
      isEmail = subscriber.productSubscriberNo?.includes('@');
      title = subscriber.productSubscriberNo;
      break;
    default:
      break;
  }

  return (
    <div className='subscriber'>
      <div className='title' title={title}><span className={`text ${isEmail ? 'ltr-direction' : ''}`}>{title}</span>{isDisplayProductStatus && <span className='product-status'>{subscriber.productStatusDesc}</span>}</div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(InternetSubscriber);
